import { Group } from "../types/Group";
import { deleteData, getData, postData, putData } from "./apiService";


export const getGroupById = async (group_id: string): Promise<Group | null> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData(`/groups/${group_id}`, {});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data as Group;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to get group:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const getGroupsByEventId = async (event_id: string): Promise<Group[]> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData(`/events/${event_id}/groups`, {});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data as Group[];  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to get groups:', error);
      return [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const removeGroup = async (group_id: string): Promise<Group | null> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await deleteData(`/groups/${group_id}`, {});  // The API call is unchanged
      return response.data as Group;
    } catch (error) {
      console.error('Failed to delete group:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const updateGroup = async (group_id: string, group: Group): Promise<Group | null> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await putData(`/groups/${group_id}`, group);  // The API call is unchanged
      return response.data as Group;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to update group:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const createGroup = async (group: Group): Promise<Group | null> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await postData(`/groups`, group);  // The API call is unchanged
      return response.data as Group;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to create group:', error);
      return null;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };
